"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
exports.combineReducers = function (reducers) {
    return redux_1.combineReducers(reducers);
};
//# sourceMappingURL=combine-reducers.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngfk/ts-redux/dist/combine-reducers.js
// module id = 102
// module chunks = 0